import {logger} from '../../../utils/logging/logger'
import {warnServerEnvironment} from '../logging/server-warning'

/**
 *
 *Get item from local storage or session storage in a safe way, logging an error when the window objects does not exists
 * @example get `searchUri` from local storage
 *
 * ```
 * safelyGetStorageItem(localStorage, 'searchUri', 'getSearchUri failed')
 * ```
 * @param storageOption - the storage where to get the item. Local storage or Session storage
 * @param param - the chosen parameter to get from the storage
 * @param errorString - the error message to log when it fails
 * @returns The value for the requested param or undefined
 */
export const safelyGetStorageItem = (
  storageOption:
    | typeof localStorage
    | typeof sessionStorage
    | 'localStorage'
    | 'sessionStorage',
  param: string,
  errorString?: string
): string | undefined | null => {
  if (typeof window === 'undefined') {
    warnServerEnvironment(`get ${storageOption}.${param}`)
    return undefined
  }
  try {
    const storage =
      typeof storageOption === 'string' ? window[storageOption] : storageOption
    return storage.getItem(param)
  } catch (err) {
    logger.error('safelyGetStorageItem:', {errorString, err})

    return undefined
  }
}
